import { render } from "./BaseCustomSelect.vue?vue&type=template&id=240f0cca"
import script from "./BaseCustomSelect.vue?vue&type=script&lang=js"
export * from "./BaseCustomSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/maksimzugan/code/nacd-3-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__